<div class="flex flex-col gap-4">

  <div class="flex items-center" [class.justify-between]="!arrayConfig()?.hideHeaderLabel" [class.justify-end]="arrayConfig()?.hideHeaderLabel">
    @if (!arrayConfig()?.hideHeaderLabel) {
      <div class="text-xs font-bold uppercase tracking-widest text-surface-500 dark:text-surface-400">
        {{ arrayConfig()?.entityName }}{{ tableData().length !== 1 ? 's' : '' }} ({{ tableData().length }} {{ tableData().length === 1 ? 'item' : 'items' }})
      </div>
    }
    <p-button [label]="'Add ' + (arrayConfig()?.entityName || 'Item')" icon="pi pi-plus" size="small" [outlined]="true"
      (onClick)="onAddClick()"></p-button>
  </div>

  <div class="page-content-card">
    <app-dynamic-table [data]="filteredTableData()" [columns]="columns()" [actions]="visibleActions()"
      [paginator]="showPaginator()"
      [showToolbar]="showTableToolbar()"
      [rows]="10" [filters]="filterConfigs()" [minWidth]="arrayConfig()?.tableMinWidth || '50rem'"
      [emptyMessage]="emptyMessage()"
      [emptySubMessage]="emptySubMessage()"
      (actionClicked)="onTableAction($event)">

      <ng-template pTemplate="description" let-value>
        @if (value && value.length > 30) {
        <span [pTooltip]="value" tooltipPosition="top" class="cursor-help">
          {{ value | slice:0:30 }}...
        </span>
        } @else {
        <span>{{ value || '-' }}</span>
        }
      </ng-template>

    </app-dynamic-table>
  </div>

  <p-dialog
    [header]="isViewOnlyDialog() ? 'View ' + (arrayConfig()?.entityName || 'Item') : (isNewItem() ? 'Add New ' + (arrayConfig()?.entityName || 'Item') : 'Edit ' + (arrayConfig()?.entityName || 'Item'))"
    [(visible)]="isDialogOpen" [modal]="true" [style]="{ width: '550px' }"
    [breakpoints]="{ '960px': '75vw', '641px': '95vw' }" [draggable]="false" [resizable]="false" appendTo="body">

    @if (activeFormGroup(); as group) {
    <div [formGroup]="group" class="grid grid-cols-12 gap-4 py-4">
      @for (field of arrayConfig()?.dialogFields; track field.key) {
      @if (!(isViewOnlyDialog() && field.key === 'hasNoExpiry') && isFieldVisible(field, group)) {
      <div [class]="(field.width || getColSpanClass(field.colSpan)) + ' ' + (field.orderClass || '')"
        [class.-mt-4]="field.isSubField">
        <app-form-field [label]="field.hideLabel ? '' : field.label" [control]="group.get(field.key)" [hint]="field.hint">
          <ng-container *ngComponentOutlet="resolveFieldComponent(field.type); injector: buildFieldInjector(field, group)" />
        </app-form-field>
      </div>
      }
      }
    </div>
    }

    <ng-template pTemplate="footer">
      @if (!isViewOnlyDialog()) {
      <div class="flex justify-end w-full gap-2 p-3 border-t border-surface-200 dark:border-surface-800">
        <p-button label="Cancel" [outlined]="true" [text]="true" severity="secondary"
          (onClick)="closeDialog()"></p-button>
        <p-button label="Save" (onClick)="saveItem()"></p-button>
      </div>
      }
    </ng-template>
  </p-dialog>
</div>
